import { CloseEntryRequest } from '@/domain/entities/review/closeEntryRequest'
import { EvaluateReviewRequest } from '@/domain/entities/review/evaluateReviewRequest'
import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { ReviewEntryDetail } from '@/domain/entities/review/reviewEntryDetail'
import { ReviewEntryRepository } from '@/domain/repositories/review/reviewEntryRepository'
import { ApiClients } from '@/infrastructure/clients/apiClients'
import { ReviewDetailEntryListDecoder, ReviewEntryListDecoder } from '@/infrastructure/decoders/review/review'

export class ReviewEntryRepositoryImpl implements ReviewEntryRepository {
  constructor(private clients: ApiClients) {}

  async getByUserIdAndProblemIdOpenEntries(userId: string, problemId: string): Promise<ReviewEntry[]> {
    const path = `review/entries/users/${userId}/problems/${problemId}`
    const data = await this.clients.reviewClient.fetchAndDecode(ReviewEntryListDecoder, path)
    return data
  }

  async getByUserIdAndProblemIdCloseEntries(userId: string, problemId: string): Promise<ReviewEntry[]> {
    const path = `review/close_entries/users/${userId}/problems/${problemId}`
    const data = await this.clients.reviewClient.fetchAndDecode(ReviewEntryListDecoder, path)
    return data
  }

  async getByEntryIdReviews(entryId: string): Promise<ReviewEntryDetail[]> {
    const path = `review/reviews/entries/${entryId}`
    const data = await this.clients.reviewClient.fetchAndDecode(ReviewDetailEntryListDecoder, path)
    return data
  }

  async postCloseEntry(entryId: string): Promise<void> {
    const post: CloseEntryRequest = {
      entryId: entryId,
      userId: '',
      apiKey: ''
    }
    const path = `review_proxy/close`
    await this.clients.aojClient.fetch(path, {
      method: 'POST',
      body: JSON.stringify(post)
    })
  }

  async postEvaluationReview(reviewId: string, score: number): Promise<void> {
    const post: EvaluateReviewRequest = {
      reviewId: reviewId,
      score: score,
      userId: ''
    }
    const path = `review_proxy/evaluation`
    await this.clients.aojClient.fetch(path, {
      method: 'POST',
      body: JSON.stringify(post)
    })
  }
}
